export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-designer-news-9d688c627c9973c081ad798965357521.svg";